import { t } from 'ttag'

import { getLanguages } from 'utils/languages'
import { POSITION_FIELD_LIMIT } from './schema'
import { fetchDepartments } from 'api/departments'

export const POSITION_FIELD = 'position'
export const DEPARTMENT_FIELD = 'department'
export const LANGUAGES_FIELD = 'languages'
export const AMOUNT_FIELD = 'positions'
export const DESCRIPTION_FIELD = 'description'

export const getFields = ({ projects }) => ({
  [POSITION_FIELD]: {
    field: 'input',
    label: t`Title`,
    limit: POSITION_FIELD_LIMIT,
    name: POSITION_FIELD,
    placeholder: t`Descriptive name`,
    isRequired: true,
  },
  [DEPARTMENT_FIELD]: {
    field: 'combobox',
    hint: t`Departments group jobs together and allow easy access management`,
    label: t`Department`,
    name: DEPARTMENT_FIELD,
    placeholder: t`Available Departments`,
    isRequired: true,
    isSearchable: true,
    fetchOptions: [
      fetchDepartments,
      ({ name, id }) => ({ label: name, value: id }),
    ],
  },
  [LANGUAGES_FIELD]: {
    field: 'combobox',
    hint: t`Selected language(s) will be available as options for candidate invitation and test language.`,
    label: t`Languages`,
    name: LANGUAGES_FIELD,
    options: getLanguages(),
    placeholder: t`Available Languages`,
    isMulti: true,
    isRequired: true,
    isSearchable: true,
  },
  [AMOUNT_FIELD]: {
    field: 'input',
    label: t`Number of open positions`,
    type: 'number',
    min: 1,
    name: AMOUNT_FIELD,
    placeholder: t`Minimum 1`,
    isRequired: true,
  },
  [DESCRIPTION_FIELD]: {
    field: 'textarea',
    hint: t`The description will not be visible for candidates.`,
    label: t`Description`,
    name: DESCRIPTION_FIELD,
    placeholder: t`Ex.: Responsibilities of the position...`,
    isOptional: true,
  },
})

export const getDefaultValues = () => ({
  [POSITION_FIELD]: '',
  [DEPARTMENT_FIELD]: null,
  [LANGUAGES_FIELD]: getLanguages(),
  [DESCRIPTION_FIELD]: '',
  [AMOUNT_FIELD]: 1,
})
